import React from 'react';
import PreviewBody, {
  InsightPreviewBody,
} from '../CustomAISummary/pages/PreviewSummary/PreviewBody';
import { usePageInfoValue } from '../CustomAISummary/hooks';
import CardCommon from '@op/components/CardCommon';

interface ICommonSummaryEmbed {
  /** 后端统一列表项原始数据（含 object_id / task_type ...） */
  ext: any;
  gameInfo: any;
  wholeGameInfo: any;
  contentRef?: any;
}

/**
 * AIInsightsReport 内嵌渲染：common 自定义 summary（普通一次性 / 订阅例行）。
 *
 * 复用 CustomAISummary 下钻页 PreviewSummary 的两个预览体，以只读模式挂载：
 *  - task_type = 'temporary'（普通/非订阅）→ PreviewBody（一次性 summary）
 *  - task_type = 'recurring'（订阅）        → InsightPreviewBody（例行 summary）
 *
 * 字段从后端统一列表项 ext 解析（object_id / task_type）。具体 key 待后端口径对齐后
 * 可能调整，此处做防御性兜底（object_id ?? id ?? task_id）。
 */
export default function CommonSummaryEmbed({
  ext,
  gameInfo,
  wholeGameInfo,
  contentRef,
}: ICommonSummaryEmbed) {
  // task_type: "temporary" → 普通（非订阅）；"recurring" → 订阅
  const isSubscript = ext?.task_type === 'recurring';
  const id = ext?.id;

  const { loading, shortId, promptInfo, reportItem } = usePageInfoValue({
    id,
    gameInfo,
    isSubscript,
  });

  return (
    <CardCommon loading={loading!} loadingHeight={600} contentCard>
      {isSubscript ? (
        <InsightPreviewBody
          wholeGameInfo={wholeGameInfo}
          gameInfo={gameInfo}
          shortId={shortId}
          reportItem={reportItem}
          contentRef={contentRef}
          promptInfo={promptInfo}
        />
      ) : (
        <PreviewBody
          wholeGameInfo={wholeGameInfo}
          gameInfo={gameInfo}
          shortId={shortId}
          contentRef={contentRef}
          promptInfo={promptInfo}
          allPreview
        />
      )}
    </CardCommon>
  );
}
